/* template */
<template><div class="union-login"><mpx-image src="https://ut-static.udache.com/webx/sfc/8P4puQvobKx3CRnGypis8.png" class="union-login-icon"/><div class="union-login-text">登录12306账号，查看中转方案</div><mpx-view @tap="login" class="union-login-button">登录12306</mpx-view></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m576fe4f9"}'>
.union-login
  display flex
  flex-direction column
  margin-top 80px
  align-items center
  &-icon
    height 55px
    width 55px
    margin-bottom 24px
  &-text
    font-family PingFangSC-Medium
    font-size 15px
    font-weight 500
    line-height 15px
    color #333
    margin-bottom 32px
  &-button
    padding 12.5px 21px
    background #338FFF
    font-family PingFangSC-Semibold
    font-size 16px
    font-weight 600
    line-height 16px
    text-align center
    color #FFFFFF
    border-radius 8px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m576fe4f9"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./union-login-card.mpx.js?isComponent&outputPath=components%2Funion-login-card576fe4f9%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./union-login-card.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Funion-login-card576fe4f9%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m576fe4f9"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/union-login-card576fe4f9/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
